import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

function CourseInfoBar({ instructor, stats }) {
  const teacherHref = instructor.id ? ROUTES.TEACHER_DETAIL(instructor.id) : null;

  const instructorContent = (
    <>
      <img
        src={instructor.avatar}
        alt=""
        className="h-[52px] w-[52px] rounded-full border-[3px] border-white object-cover shadow-sm sm:h-14 sm:w-14"
      />
      <div>
        <p className="text-sm font-bold uppercase tracking-wide text-[#1A87CC] sm:text-[15px]">
          {instructor.name}
        </p>
        <p className="text-xs font-medium text-[#888888] sm:text-sm">{instructor.role}</p>
      </div>
    </>
  );

  return (
    <div className="relative z-20 -mt-10 sm:-mt-12 lg:mr-[360px]">
      <div className="rounded-2xl bg-gradient-to-r from-white to-[#BDB7FF] p-[2px] shadow-[0_4px_20px_rgba(0,0,0,0.20)]">
        <div className="flex flex-col gap-4 rounded-[14px] bg-gradient-to-r from-[#C5E4FF] to-[#EDC7FF] px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-8 sm:py-5">
          {teacherHref ? (
            <Link
              to={teacherHref}
              className="group flex items-center gap-3 transition hover:opacity-90"
            >
              {instructorContent}
            </Link>
          ) : (
            <div className="flex items-center gap-3">{instructorContent}</div>
          )}

          <div className="flex flex-wrap items-center gap-5 sm:gap-10 lg:gap-14">
            <StatItem
              icon={
                <svg className="h-5 w-5 text-[#69991D]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              }
              label={`Chapter-${stats.chapters}`}
            />
            <StatItem
              icon={
                <svg className="h-5 w-5 text-[#1A87CC]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              }
              label={`Lecture-${stats.lectures}`}
            />
            <StatItem
              icon={
                <svg className="h-5 w-5 text-[#9369CC]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              }
              label={`Duration- ${stats.duration}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function StatItem({ icon, label }) {
  return (
    <div className="flex items-center gap-2">
      {icon}
      <span className="text-sm font-semibold text-[#1B1B1B]">{label}</span>
    </div>
  );
}

export default CourseInfoBar;
